module.exports = __webpack_public_path__ + "img/mile6-m@2.82c96882.webp";